const BACKURL_KEY = 'paid_backurl_';
const ORIGINAL_REF_KEY = 'paid_originalref_';

export const saveBackUrl = (key: string, backurl: string): void => {
  try {
    localStorage.setItem(BACKURL_KEY + key, backurl);
  } catch {}
};

export const getBackUrl = (key: string): string | null => {
  try {
    return localStorage.getItem(BACKURL_KEY + key);
  } catch {
    return null;
  }
};

export const clearBackUrl = (key: string): void => {
  try {
    localStorage.removeItem(BACKURL_KEY + key);
  } catch {}
};

export const saveOriginalReference = (key: string, reference: string): void => {
  try {
    localStorage.setItem(ORIGINAL_REF_KEY + key, reference);
  } catch {}
};

export const getOriginalReference = (key: string): string | null => {
  try {
    return localStorage.getItem(ORIGINAL_REF_KEY + key);
  } catch {
    return null;
  }
};

export const clearOriginalReference = (key: string): void => {
  try {
    localStorage.removeItem(ORIGINAL_REF_KEY + key);
  } catch {}
};

export const redirectToBackUrl = (backurl: string, paymentId: string): void => {
  let target: string;
  try {
    const url = new URL(backurl);
    url.searchParams.set('id', paymentId);
    target = url.toString();
  } catch {
    const sep = backurl.includes('?') ? '&' : '?';
    target = `${backurl}${sep}id=${encodeURIComponent(paymentId)}`;
  }
  window.location.replace(target);
};
